import { defineNuxtPlugin } from '#app'
import {Centrifuge} from 'centrifuge';

export default defineNuxtPlugin(nuxtApp => {
    // Створюємо інстанс, але не викликаємо .connect() прямо тут
    const centrifuge = new Centrifuge(nuxtApp.$config.public.centrifugoEndpoint, {
        debug: Boolean(nuxtApp.$config.public.centrifugoDebug || false)
    })

    centrifuge.on('connecting', (ctx) => {
        console.debug('[centrifuge] Connecting to Centrifuge', ctx)
    })

    centrifuge.on('connected', ctx => {
        console.debug('[centrifuge] Connected to Centrifuge', ctx)
    })

    centrifuge.on('disconnected', ctx => {
        console.debug('[centrifuge] Disconnected of Centrifuge', ctx)
    })

    return {
        provide: {
            centrifuge
        }
    }
})
